import { FC } from 'react';

import styles from './SbSharedWordpressArticlesContainer.scss';

export const SbSharedWordpressArticlesContainer: FC = ({ children }) => {
    return <div className={styles.container}>{children}</div>;
};
